import { Api } from './axios-config';

export interface IBlockerView {
  id: number;
  startDate: Date;
  endDate: Date;
  startTime: string;
  endTime: string;
  businessEmployeeId?: number;
  businessId: number;
  daysOfWeek: number[];
  reason?: string;
  employeeColor: string;
  employeeName: string;
  businessName: string;
}

const getById = async (id: number): Promise<IBlockerView> => {
  try {
    const { data } = await Api.get<IBlockerView>(`/blocker/${id}`);
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const get = async (
  businessId?: number,
  businessEmployeeId?: number,
  startDate?: Date,
  endDate?: Date
): Promise<IBlockerView[]> => {
  try {
    const queryParams = {
      businessId: businessId?.toString(),
      businessEmployeeId: businessEmployeeId?.toString(),
      startDate: startDate?.toISOString() || '',
      endDate: endDate?.toISOString() || '',
    };

    const { data } = await Api.get('/blocker', {
      params: queryParams,
    });

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

export interface ICreateBlocker {
  startDate: string;
  endDate?: string;
  startTime: string;
  endTime: string;
  businessEmployeeId?: number;
  businessId: number;
  daysOfWeek: number[];
  reason: string;
}

const create = async (body: ICreateBlocker): Promise<number> => {
  try {
    const { data } = await Api.post('/blocker', body);
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

export interface IUpdateBlocker {
  id: number;
  date: Date;
  startTime: string;
  endTime: string;
  businessEmployeeId: number;
  businessId: number;
  reason?: string;
}

const update = async (body: IUpdateBlocker): Promise<IBlockerView> => {
  try {
    const { data } = await Api.put('/blocker', body);
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const remove = async (id: number): Promise<void> => {
  try {
    await Api.delete(`/blocker/${id}`);
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

export const blockerService = {
  getById,
  get,
  create,
  update,
  remove,
};
